import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export type TranslationValues = Record<string, string | number | boolean | null | undefined>;

export type Translator = (key: string, values?: TranslationValues) => string;

export function useTranslations(namespace?: string): Translator {
  const intl = useIntl();

  return useCallback<Translator>(
    (key, values) => {
      const id = namespace ? `${namespace}.${key}` : key;
      return intl.formatMessage({ id, defaultMessage: id }, values);
    },
    [intl, namespace]
  );
}
